import React from "react";

export const filtersItems = [
  {
    filterKey: "assinatura",
    filterValue: true,
    tooltip: "Com assinatura",
    icon: (filtered) => (
      <i
        className="ri-pen-nib-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#0041D9" }}
      />
    ),
  },
  {
    filterKey: "assinatura",
    filterValue: false,
    tooltip: "Sem assinatura",
    icon: (filtered) => (
      <i
        className="ri-pen-nib-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#555770" }}
      />
    ),
  },
  {
    filterKey: "prioridade",
    filterValue: true,
    tooltip: "Com prioridade",
    icon: (filtered) => (
      <i
        className="ri-product-hunt-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#0041D9" }}
      />
    ),
  },
  {
    filterKey: "prioridade",
    filterValue: false,
    tooltip: "Sem prioridade",
    icon: (filtered) => (
      <i
        className="ri-product-hunt-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#555770" }}
      />
    ),
  },
  {
    filterKey: "justificativa",
    filterValue: false,
    tooltip: "Atendimento dentro da empresa",
    icon: (filtered) => (
      <i
        className="ri-map-pin-user-fill"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#0041D9" }}
      />
    ),
  },
  {
    filterKey: "justificativa",
    filterValue: true,
    tooltip: "Atendimento fora da empresa",
    icon: (filtered) => (
      <i
        className="ri-map-pin-user-fill"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#555770" }}
      />
    ),
  },
  {
    filterKey: "anotacao",
    filterValue: true,
    tooltip: "Com anotação",
    icon: (filtered) => (
      <i
        className="ri-pencil-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#0041D9" }}
      />
    ),
  },
  {
    filterKey: "anotacao",
    filterValue: false,
    tooltip: "Sem anotação",
    icon: (filtered) => (
      <i
        className="ri-pencil-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#555770" }}
      />
    ),
  },
  {
    filterKey: "planoAcao",
    filterValue: true,
    tooltip: "Com Orientação",
    icon: (filtered) => (
      <i
        className="ri-file-edit-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#0041D9" }}
      />
    ),
  },
  {
    filterKey: "planoAcao",
    filterValue: false,
    tooltip: "Sem Orientação",
    icon: (filtered) => (
      <i
        className="ri-file-edit-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#555770" }}
      />
    ),
  },

  {
    filterKey: "anexos",
    filterValue: true,
    tooltip: "Com Anexos",
    icon: (filtered) => (
      <i
        className="ri-attachment-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#0041D9" }}
      />
    ),
  },
  {
    filterKey: "anexos",
    filterValue: false,
    tooltip: "Sem Anexos",
    icon: (filtered) => (
      <i
        className="ri-attachment-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#555770" }}
      />
    ),
  },
  {
    filterKey: "foto",
    filterValue: true,
    tooltip: "Com foto",
    icon: (filtered) => (
      <i
        className="ri-camera-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#0041D9" }}
      />
    ),
  },
  {
    filterKey: "foto",
    filterValue: false,
    tooltip: "Sem foto",
    icon: (filtered) => (
      <i
        className="ri-camera-line"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#555770" }}
      />
    ),
  },
  {
    filterKey: "classificacao",
    filterValue: "AVANCADO",
    tooltip: "Avançado",
    icon: (filtered) => (
      <p style={{ color: filtered ? "#FFFFFF" : "#0dbaba", fontSize: "1rem" }}>
        A
      </p>
    ),
  },
  {
    filterKey: "classificacao",
    filterValue: "INTERMEDIARIO",
    tooltip: "Intermediário",
    icon: (filtered) => (
      <p style={{ color: filtered ? "#FFFFFF" : "#666bfd", fontSize: "1rem" }}>
        I
      </p>
    ),
  },
  {
    filterKey: "classificacao",
    filterValue: "BASICO",
    tooltip: "Básico",
    icon: (filtered) => (
      <p style={{ color: filtered ? "#FFFFFF" : "#d984ed", fontSize: "1rem" }}>
        B
      </p>
    ),
  },
  {
    filterKey: "acesso",
    filterValue: true,
    tooltip: "Acessou o app",
    icon: (filtered) => (
      <i
        className="ri-user-follow-fill"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#05A763" }}
      />
    ),
  },
  {
    filterKey: "acesso",
    filterValue: false,
    tooltip: "Não acessou o app",
    icon: (filtered) => (
      <i
        className="ri-user-unfollow-fill"
        style={{ fontSize: "1rem", color: filtered ? "#FFFFFF" : "#F4455A" }}
      />
    ),
  },
];
